import GTranslate from "./GTranslate";

const logo =
  "https://cdn.outfall.website/Images/Logo/OutFall%20Logo%20Orange.png";

export default function Footer() {
  const columns = [
    {
      title: "Community",
      links: [
        { label: "News", href: "/home#news" },
        { label: "Updates", href: "/home#news" },
        { label: "Events", href: "/home#news" },
        { label: "Discord", href: "https://discord.gg/tEQPb9m6" },
      ],
    },
    {
      title: "Support",
      links: [
        { label: "Status", href: "/status" },
        { label: "Appeal a Ban", href: "/ban-appeal" },
      ],
    },
    {
      title: "Company",
      links: [
        { label: "Careers", href: "/careers" },
        {
          label: "Contact",
          href: "https://mail.google.com/mail/?view=cm&fs=1&to=contact@outfall.website",
        },
        { label: "Staff Team", href: "/our-team" },
      ],
    },
    {
      title: "Legal",
      links: [
        { label: "Terms of Service", href: "/terms-of-services" },
        { label: "Privacy Policy", href: "/privacy-policy" },
        { label: "Cookie Policy", href: "/cookie-policy" },
        { label: "Staff Agreement", href: "/staff-agreement" },
      ],
    },
    {
      title: "Resources",
      links: [
        {
          label: "Roblox Page",
          href: "https://www.roblox.com/games/110212419089220/Outfall-Beta-Release",
        },
        { label: "My Application", href: "/my-application" },
        { label: "Appeal a Ban", href: "/ban-appeal" },
      ],
    },
  ];

  function isExternal(url) {
    return url.startsWith("http");
  }

  return (
    <footer className="bg-[#17181d] px-6 py-16 text-white md:px-[7%]">
      <div className="flex flex-col gap-8 border-b border-white/15 pb-10 md:flex-row md:items-center md:justify-between">
        <img src={logo} alt="Outfall" className="h-14 w-auto object-contain" />

        <div className="flex flex-wrap items-center gap-5">
          <div className="flex items-center gap-3 text-sm font-black uppercase text-white/70">
            <span>Language</span>

            <div data-no-translate>
              <GTranslate />
            </div>
          </div>

          <a
            href="https://discord.gg/tEQPb9m6"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#ffd978]"
            data-no-translate
          >
            <img
              src="https://www.svgrepo.com/show/353655/discord-icon.svg"
              alt="Discord"
              className="h-7 w-7 brightness-0 invert transition hover:brightness-100"
            />
          </a>
        </div>
      </div>

      <div className="grid gap-10 border-b border-white/15 py-10 sm:grid-cols-2 lg:grid-cols-4">
        {columns.map((column) => (
          <div key={column.title}>
            <h3 className="mb-5 text-lg font-black text-white">
              {column.title}
            </h3>

            <ul className="space-y-3">
              {column.links.map((link) => (
                <li key={`${column.title}-${link.label}`}>
                  <a
                    href={link.href}
                    target={isExternal(link.href) ? "_blank" : undefined}
                    rel={
                      isExternal(link.href) ? "noopener noreferrer" : undefined
                    }
                    className="text-sm font-semibold text-white/70 hover:text-[#ffd978]"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="flex flex-col gap-8 pt-10 lg:flex-row lg:items-start lg:justify-between">
        <div className="max-w-3xl">
          <p className="text-sm font-semibold leading-relaxed text-white/70">
            © 2026 Outfall. All rights reserved. Outfall is an independent
            Roblox battle royale experience. Roblox and all related marks are
            trademarks of Roblox Corporation.
          </p>

          <div className="mt-8 flex flex-wrap gap-7 text-sm font-semibold text-white/70">
            <a href="/terms-of-services" className="hover:text-[#ffd978]">
              Terms of Service
            </a>

            <a href="/privacy-policy" className="hover:text-[#ffd978]">
              Privacy Policy
            </a>

            <a href="/cookie-policy" className="hover:text-[#ffd978]">
              Cookie Policy
            </a>

            <a href="/staff-agreement" className="hover:text-[#ffd978]">
              Staff Agreement
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
